import { Container } from '@mui/system';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Divider,
    ImageList,
    ImageListItem,
    Stack,
    TextField,
    Typography,
    useMediaQuery,
    useTheme
} from '@mui/material';
import SmsIconYellow from '../../assets/icons/SmsIconYellow';
import {
    openSignupModalState,
    openVideoModalState
} from '../../Feature/App/AppSlice';
import { useAppDispatch } from '../../Feature/Store/Store';
import YellowAirplaneRightMobile from '../../assets/icons/YellowAirplaneRightMobile';
import YellowAirplaneRight from '../../assets/icons/YellowAirplaneRight';
import yellowMobile from '../../assets/Images/YellowLogoIconMobile.webp';
import yellowLogo from '../../assets/Images/YellowLogoIcon.webp';

type GetEmailProps = {
    formik: any;
};

const UpdateSection = ({ formik }: GetEmailProps) => {
    const dispatch = useAppDispatch();

    const navigate = useNavigate();
    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('lg'));
    const medium = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Stack
            sx={{
                width: '100%',
                position: 'relative',
                backgroundColor: '#05668D',
                backgroundSize: 'cover',
                padding: mobile ? '40px 16px' : '40px 60px 40px 60px'
            }}
        >
            <Container
                maxWidth="xl"
                disableGutters
                sx={{
                    display: 'flex',
                    maxWidth: '100%',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    gap: mobile ? '24px' : '32px',
                    backgroundColor: '#05668D',
                    backgroundSize: '100%'
                    // margin: '0',
                }}
            >
                <Box
                    maxWidth={'xl'}
                    sx={{
                        display: 'flex',
                        flexDirection: mobile ? 'column-reverse' : 'row',
                        alignItems: mobile ? 'flex-start' : 'center',
                        justifyContent: 'space-between',
                        gap: mobile ? '8px' : '0',
                        // mt: mobile ? '0' : 0,
                        margin: medium ? '40px 0px' : undefined
                    }}
                >
                    <Typography
                        sx={{
                            fontFamily: 'CabinetGrotesk-Variable',
                            fontWeight: 700,
                            fontSize: mobile ? '24px' : '44px',
                            lineHeight: mobile ? '28px' : '66px',
                            color: '#FFFFFF',
                            mb: mobile ? '0px' : 0
                        }}
                    >
                        Never miss an update from us
                    </Typography>
                    <ImageList
                        onClick={() => {
                            navigate('/');
                        }}
                        sx={{
                            display: 'flex',
                            transition: 'all .4s ease',
                            cursor: 'pointer',
                            '&:hover': {
                                opacity: 0.8
                            },
                            mt: mobile ? '0px' : 0,
                            mb: '8px',
                            justifyContent: 'space-between'
                        }}
                        cols={1}
                    >
                        <ImageListItem>
                            {mobile ? (
                                <img src={yellowMobile} alt="logo" />
                            ) : (
                                <img src={yellowLogo} alt="logo" />
                            )}
                        </ImageListItem>
                    </ImageList>
                </Box>
                <Box sx={{ flexDirection: 'column' }}>
                    <Typography
                        sx={{
                            fontFamily: 'Outfit',
                            fontSize: mobile ? '14px' : '24px',
                            fontWeight: 400,
                            lineHeight: mobile ? '21px' : '36px',
                            color: '#C5C5C5',
                            gap: '24px'
                        }}
                    >
                        Stay in the know with our latest updates, exclusive
                        offers, and valuable insights delivered right to your
                        inbox. Leave your email today to join our newsletter
                        community and never miss out on what's happening.
                    </Typography>
                </Box>

                <Box>
                    <Stack
                        direction="row"
                        useFlexGap
                        alignItems="center"
                        p="24px"
                        sx={{
                            height: mobile ? '60px' : '91px',
                            color: '#FFFFFF',
                            border: '4px solid #FFFFFF',
                            borderRadius: '100px',
                            fontFamily: 'Outfit',
                            fontSize: mobile ? '20px' : '24px',
                            fontWeight: 700,
                            lineHeight: '28px',
                            letterSpacing: '0.02em',
                            gap: '20px',
                            mb: mobile ? '0px' : 0
                        }}
                    >
                        <TextField
                            id="email"
                            type="email"
                            variant="standard"
                            margin="normal"
                            required
                            name="email"
                            autoComplete="Email Address"
                            value={formik?.values?.email}
                            onChange={formik.handleChange}
                            sx={{
                                // width: '100%',
                                flex: 1,
                                color: '#FFFFFF',
                                fontSize: medium ? '14px' : '26px',
                                fontWeight: '500',
                                lineHeight: '24px',
                                m: 0
                            }}
                            placeholder={'ENTER EMAIL ADDRESS'}
                            InputProps={{
                                style: {
                                    color: '#FFFFFF',
                                    fontWeight: 500,
                                    fontSize: mobile ? '14px' : '29px'
                                },
                                startAdornment: (
                                    <>
                                        <SmsIconYellow />
                                        <Divider
                                            sx={{
                                                mx: '8px',
                                                my: '0',
                                                height: '24px'
                                            }}
                                        />
                                    </>
                                ),
                                disableUnderline: true,
                                endAdornment: (
                                    <Box
                                        sx={{
                                            transition: 'all .4s ease',
                                            cursor: 'pointer',
                                            alignSelf: 'center',
                                            pt: '8px',
                                            '&:hover': {
                                                opacity: 0.8
                                            }
                                        }}
                                        onClick={() =>
                                            dispatch(openSignupModalState())
                                        }
                                    >
                                        {mobile ? (
                                            <YellowAirplaneRightMobile />
                                        ) : (
                                            <YellowAirplaneRight />
                                        )}
                                    </Box>
                                )
                            }}
                        />
                    </Stack>
                </Box>
            </Container>
        </Stack>
    );
};

export default UpdateSection;
